// src/api/media.ts
import api from './client';

export interface MediaAsset {
  id: number;
  filename: string;
  mime_type: string;
  storage_key: string;
  width?: number | null;
  height?: number | null;
  size_bytes: number;
  title?: string | null;
  description?: string | null;
  tags?: string[];
  created_at?: string;
  created_by?: number | null;
  url?: string;
}

export const listMedia = async (): Promise<MediaAsset[]> => {
  const response = await api.get('/media');
  return response.data;
};

export const uploadMedia = async (file: File, fields?: {
  title?: string;
  description?: string;
  tags?: string;
}): Promise<MediaAsset> => {
  const formData = new FormData();
  formData.append('file', file);
  if (fields?.title) formData.append('title', fields.title);
  if (fields?.description) formData.append('description', fields.description);
  if (fields?.tags) formData.append('tags', fields.tags);
  const response = await api.post('/media/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const updateMedia = async (id: number, data: {
  title?: string;
  description?: string;
  tags?: string;
}): Promise<MediaAsset> => {
  const response = await api.put(`/media/${id}`, data);
  return response.data;
};

export const deleteMedia = async (id: number): Promise<void> => {
  await api.delete(`/media/${id}`);
};

/** Публичный URL файла (без auth-хедера), т.к. /api/media/{id}/file отдаёт FileResponse. */
export const mediaFileUrl = (id: number): string => `/api/media/${id}/file`;